import { render } from "./SupportInfo.vue?vue&type=template&id=6c2ed785&scoped=true"
import script from "./SupportInfo.vue?vue&type=script&lang=js"
export * from "./SupportInfo.vue?vue&type=script&lang=js"

import "./SupportInfo.vue?vue&type=style&index=0&id=6c2ed785&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2ed785"]])

export default __exports__